import { __makeTemplateObject } from "tslib";
import { css } from 'styled-components';
export var shape1 = css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  border-radius: 2px;\n"], ["\n  border-radius: 2px;\n"])));
var templateObject_1;
//# sourceMappingURL=shapes.styled.js.map